import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { reportingYear } from "../../../constants";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import MethodChooser from "../../choosers/MethodChooser";
import ShareOfUsersChart from "./ShareOfUsersChart";

const ShareOfUsersChartWidget = props => {
  const [methodId, setMethodId] = useState();

  const ref = useRef();

  return (
    <DataViewerFrame
      dataViewerId="share_of_users_chart"
      reference="Figure 2.2"
      title={`Share of Users, ${reportingYear}`}
      subtitle="Comparison by GNI Group and Sector"
      contentWidth={500}
      filters={[
        <MethodChooser
          id="figure-2-2"
          methods={props.database.methods}
          selectedKey={methodId}
          onChange={methodId => {
            setMethodId(methodId);

            props.onChange({
              widget: "theme2.shareOfUsersChart",
              payload: {
                methodId
              }
            });
          }}
        />
      ]}
      chartRef={ref}
      chartSettings={{
        method: methodId ? props.database.methods[methodId] : "All"
      }}
    >
      <ShareOfUsersChart ref={ref} data={props.data} />
    </DataViewerFrame>
  );
};

ShareOfUsersChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ShareOfUsersChartWidget;
